import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: '1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2',
      type: 'Container',
      name: 'backgrounds',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '3',
      type: 'Container',
      name: 'nodesContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '4',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_1',
      parent: '2',
      data: ''
    },
    {
      id: '7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1352,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_2',
      parent: '2',
      data: ''
    },
    {
      id: '8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2704,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_3',
      parent: '2',
      data: ''
    },
    {
      id: '10',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5408,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_5',
      parent: '2',
      data: ''
    },
    {
      id: '9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4056,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_4',
      parent: '2',
      data: ''
    },
    {
      id: '11',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6760,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_6',
      parent: '2',
      data: ''
    },
    {
      id: '12',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8112,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_7',
      parent: '2',
      data: ''
    },
    {
      id: '13',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9464,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world20_8',
      parent: '2',
      data: ''
    },
    {
      id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 327,
      y: 552,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8884afd5-8f2d-44ae-831b-a0df04a36866',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 372,
      y: 620,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c56a4b86-98b7-4ec0-b728-fe30baee7ff2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 464,
      y: 627,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'dac4f1f2-8528-4c75-868b-f68feade1221',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 536,
      y: 575,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a2651322-2bc1-4d56-8712-14685272003b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 605,
      y: 519,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'edb04db8-c35f-4783-b462-a9b7ba8aa456',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 675,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '58a42d11-8ab1-45d4-bb5e-fcae94c26508',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 744,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cc86d8a3-2258-4c44-93d3-74af86276f91',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 812,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '65e2b307-d242-48b0-95eb-1b851fc8822b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 880,
      y: 305,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd1658f78-a6e5-490e-9bcf-46d41d0207f9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 946,
      y: 249,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '158b3e0a-9a75-449c-9855-a889b99d4709',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1030,
      y: 278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '373d8531-3869-4305-943e-e1719260a82b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1097,
      y: 331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a5c7c205-8287-4536-a6ab-b3438afe7137',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1185,
      y: 306,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f232c32b-b9fa-4267-89a6-474b59ec1920',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1277,
      y: 296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '77ebc73d-eb8a-4eca-9d0e-ddbd78fd03df',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1309,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1f7831d2-2970-4e00-810c-50ec861246a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1395,
      y: 406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e92c1f65-935d-4efe-a9a5-d2c4b600a268',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1491,
      y: 401,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2bb0f9c8-1c7b-448d-8cdb-24a2d3b30eb3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1579,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a28344ac-2eeb-4e01-8453-5870d39280ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1664,
      y: 322,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd6011d04-2b5f-413c-834c-eae9f8090dce',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1757,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9f68d750-74f3-4663-9ad2-5575a2c52b4d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1839,
      y: 384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '634d57be-d27b-4d23-b2a0-b4faa3cacf70',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1917,
      y: 436,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2c565eb6-d584-4e2d-ae37-6b80edecc538',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2009,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e1d7a7f5-7921-4863-abad-1c9367a7a822',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2105,
      y: 450,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0fa8b741-6e72-4a1b-959e-4f9db0cf8dc2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2201,
      y: 439,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '06da5755-7c46-4f65-8e99-eebc2aa21cfc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2292,
      y: 467,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '75146a5c-88c2-437e-8cbb-98c814c5cc8f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2380,
      y: 501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a92713c2-5e91-43c9-8c48-c9fa7afc3d40',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2473,
      y: 478,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8427bab6-0222-4717-9d42-e3f29448f07d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2552,
      y: 428,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '710f19b6-2879-499c-8a7c-7a5d30edacbd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2627,
      y: 373,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a86a0c1a-e627-48f1-b6f4-50152f291ffd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2712,
      y: 334,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '755f87e6-fa1d-4514-8f6b-919e87d1240f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2808,
      y: 349,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c2496eba-b86d-4788-b579-800001bfb8da',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2899,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '45a9c611-96c9-4a57-a278-cc62115331fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2995,
      y: 393,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '43c447d7-2b63-4967-9160-bd0e0bef846b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3091,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74fb1f41-1cfe-4a71-9811-08457baeea2e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3170,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e01e2b56-68bb-4f03-8209-576a165b660f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3253,
      y: 285,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f7f1541c-5ef5-4a61-aab1-1ebeb2d02444',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3347,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b8b6f4ae-9c67-4781-b62b-051c0c611cd8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3438,
      y: 291,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '383ae1e3-f441-427f-9fbe-0c514e1fd507',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3521,
      y: 334,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '41ae2125-e4d4-4c91-9a21-aa3bdce1245e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3600,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '454c2221-4f94-4c0e-8d9b-a80e53804de3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3686,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5f21fbdb-bffe-4910-86dc-99d69145cd4f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3781,
      y: 420,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9d595f4f-1e38-4f4e-b2ed-46f188399923',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3874,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'dbfe6f1a-abc8-4bfe-831e-3af7daa8a4ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3955,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '30453416-7db2-4e8f-b854-791179ab71eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4044,
      y: 320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1fde8cf6-c0d9-49a4-aa92-ddb5655e7b43',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4141,
      y: 311,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c96fa598-4ef9-4698-8410-5a799cd4ebd2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4240,
      y: 324,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f231fddf-eed6-42ef-8404-ce5e87ac4371',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4329,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2e0c2a48-5031-436b-93fe-058049af6be8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4410,
      y: 410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a6bf972f-e9cc-45ed-a3ba-5473673209f9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4509,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a3a5218d-6e1c-4d4e-89bb-f87358c8bd74',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4606,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f85c583f-81f6-4ba3-9fc3-53f1b86e2e0e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4698,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '73752ca2-020c-4268-9321-61467cb87605',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4799,
      y: 364,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '60932f75-d379-4b01-95f0-0236c1cefa0b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4897,
      y: 358,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'db53da6c-8d59-4acd-b0e7-50e90af0c9b9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4991,
      y: 386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '04d25b90-3fdd-4b80-ace1-65d7b9c42374',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5055,
      y: 451,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '30d2bbc2-0bb7-4f8f-b896-0321375eafca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5146,
      y: 480,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '76a164e9-9d58-4d17-a7a6-76c114267449',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5238,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4b9e64e2-812c-4f9a-bfaa-bdbadc7af08a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5325,
      y: 420,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '53ad241d-424c-46fb-9437-d3499bb58b35',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5417,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e6264243-a18a-4a13-8be7-64f5f637b51b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5509,
      y: 413,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4b5f462e-01f8-49f6-8363-158860d44846',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5589,
      y: 460,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '27c7d796-ce94-4176-8419-e4bb293add13',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5673,
      y: 504,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'baa419be-6d99-401c-8849-db37f4c54efe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5768,
      y: 525,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1f4f9e40-ae6e-4c0f-8e6e-f2daaab79e20',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5867,
      y: 526,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6a6c333c-5df9-4fe7-a38b-5ec05c0a212f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5965,
      y: 516,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '53a34bd5-abc5-4c8c-991c-766cc15d3c72',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6058,
      y: 488,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5df91a8b-62dd-4d6e-b177-92f9ed70fa77',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6137,
      y: 440,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a1f132a1-7a25-4114-8360-31d0b2109064',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6224,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '940a596c-8632-405f-8332-84071471aec7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6314,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e76226cb-ca5e-4fc9-8ab3-71a9cbd8854c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6410,
      y: 366,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1a6f1ce6-f268-49a1-99d6-3f0e22c42bc6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6503,
      y: 389,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd79af378-3a66-4641-881d-95ef49bf248d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6593,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9d654ab3-cf03-442d-8144-0c2004e54b0a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6690,
      y: 428,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cb646b69-bb49-4b4b-8135-beb58ca6f0b8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6780,
      y: 389,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '05a651ac-ba81-4cb5-a0cd-fca75c6dbf25',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6864,
      y: 343,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '48c6bc2f-daa7-4bc0-83aa-5269d39f332d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6963,
      y: 339,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bde424e0-4449-4299-81f5-39d6642eadfd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7056,
      y: 305,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6e5701fd-610a-443d-8e75-f202163303d7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7132,
      y: 250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3709b114-b73c-4f7c-8cb6-514841b316d4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7228,
      y: 226,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1e93a51c-d8e6-4b15-94fb-2513520d0923',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7316,
      y: 259,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '271395dc-962e-4fd0-93ca-df532bc2c01d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7404,
      y: 294,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7cf9f0c1-a43f-40c6-88a1-efd6b77529fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7487,
      y: 333,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c03c68ee-4d58-407d-9636-9e93dfd23609',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7565,
      y: 382,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '08361ab1-22e7-4368-8699-5d356bae9a30',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7656,
      y: 411,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2e006ec9-eeb6-4400-a374-ab9373ff50dd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7746,
      y: 438,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0589c65f-db64-4737-ba53-9292fa56f07a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7840,
      y: 414,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7cfe9289-a256-40e0-9ff8-e3bb80d28218',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7939,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c45a0af0-1184-434b-8337-548ef177c898',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8035,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fd68599f-38c9-47a3-92ea-669902f2b12e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8121,
      y: 372,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fe01d4a0-3ebd-4738-b7da-9304988ccfae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8209,
      y: 331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '222b433e-10e1-44fc-9ba6-c9be130d4ff7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8302,
      y: 303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f28f5c60-c90f-4b14-bfb2-e3c90f0bae4e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8399,
      y: 295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cdfe5351-5126-4b76-86a9-5bb0fc251b69',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8497,
      y: 304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a3571be9-1997-4482-bc72-36f7c221d526',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8579,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f6310269-4067-4649-ba30-58614078808f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8636,
      y: 413,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3ce08315-f530-4bce-b578-6c762a2326db',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8703,
      y: 473,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c8640c2b-0be0-4e8e-95d3-74c226cfaeeb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8794,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e635b46a-5ad9-4431-a5ce-dc2845d62285',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8878,
      y: 457,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '88441f08-3731-42f4-a1f0-8bcdb2b845c6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8941,
      y: 394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '30858b54-a3c5-43e7-bcaf-1fdc585a7b60',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9031,
      y: 361,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd63838e1-91ba-40d4-bbcb-cd6fd7e26b67',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9118,
      y: 392,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'dd791f58-3866-4394-a8ed-4c5eeb302b35',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9208,
      y: 420,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1542c991-d841-4b16-8ab7-d282ca6af60c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9303,
      y: 429,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a9672737-412b-4689-a367-64cfedc73b39',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9387,
      y: 468,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fb498e4f-07e3-43b8-957a-923577e7e02e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9460,
      y: 521,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3a5f7412-aec5-4ca9-b981-98f843dd5350',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9540,
      y: 562,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '230876e2-b1fb-4c11-b4bb-c101787e5907',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9611,
      y: 504,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ebc9fb20-7630-4fc8-a62f-03c25d0fbb04',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9661,
      y: 431,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '18da039a-c183-474b-a8af-3391a41d96a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9726,
      y: 365,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e8065878-ecb0-4f05-9dff-9081b0b6b659',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9810,
      y: 324,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '40bb59c6-a7c6-4afc-b3fe-8ab50d1bc1eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9900,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bb8dffb9-4b87-436c-b774-183f8c0ad348',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9951,
      y: 419,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e11a0791-f99b-4b61-86a3-c0ca4f211bf3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10003,
      y: 488,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd11cb59d-0a93-49c8-8e52-99a1c38b8947',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10071,
      y: 547,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '667436c5-0dad-4a05-ba79-5fc7662debbc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10163,
      y: 521,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c4bf2b86-67f3-4eca-a06e-eb6f9ecb6853',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10207,
      y: 448,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4b820867-1a31-4e06-b49a-1c1d1a7d860b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10284,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7f656862-19d3-4e2d-9b5c-375cdc3df52f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10380,
      y: 399,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '110',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '164',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '185',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '214',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '219',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '224',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '1b355a2e-d409-489c-8af4-a150c082b42b',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '106',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '160',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '181',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '210',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '215',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '220',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '225',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '230',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'f24cf61d-696e-47f7-9788-8dc5a3d75bef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 907,
      y: 515,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '95f0f68e-060b-49af-8a59-62c6b7f67e83',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 833,
      y: 579,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '7613f3e8-e696-4499-9da0-cdc60161fe0e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 758,
      y: 649,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'dd162a1d-f3e1-4b2d-8550-0a39043761c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 673,
      y: 725,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '26b09318-24d9-4c91-9a35-c197fd5c509b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1011,
      y: 492,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '4cb23723-c8c5-4a1f-8ea5-24e57e52c3c7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 948,
      y: 573,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '9d30df1a-6434-4300-a9a1-6a339f91458d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 875,
      y: 645,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'beee4870-8a7f-4678-893b-55a47420ac57',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 791,
      y: 717,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fd06d917-6ba7-4b5f-8816-dd71a7e6cc25',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1128,
      y: 524,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '68db9862-c898-4080-a90e-a141c08df8fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1057,
      y: 576,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '1b16afd1-becb-4769-8829-2d48fd172771',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1224,
      y: 525,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '3ba47fc2-fcfa-4353-93d4-49f919c99c6a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 971,
      y: 648,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '09fa28ac-aa37-44ce-b9be-5fe93f6a5fd4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 718,
      y: 775,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '70218171-7e30-435b-8107-55e3debc8b7c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1155,
      y: 584,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '845729e2-a7f5-41ba-9342-0a31b42de0ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1071,
      y: 654,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ad11dc20-c53c-490a-84a8-e065209c9149',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 995,
      y: 722,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '0ef1a73a-3cd5-4068-8731-145c83cbe006',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 886,
      y: 722,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '19a6077e-c3ca-497d-906a-8ef59e9a90a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 937,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd2fefd43-f6b7-40d5-9c39-61c08dbba1ad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1240,
      y: 597,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '0a2885c0-a51b-46d6-8bdc-0004ee2f4233',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1288,
      y: 15,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'aaf45f1c-8a32-4c39-85ad-df6c96bfe99e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1220,
      y: 71,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '767c6f9d-e648-495f-bf8b-45366bf02a1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1147,
      y: 121,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '5d0a2d97-f62a-48ce-a24b-abbe67cbc48d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1362,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '6968426c-e5bc-4dff-bfdf-e653dfaa4119',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1280,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '4c0ecb23-29a9-45a1-9877-732ad375e2ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1206,
      y: 166,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '8c8bdb0b-bece-411e-b8ac-408e91db745e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1501,
      y: 27,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd2e268f9-cb1e-4375-a580-e155e5264a14',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1430,
      y: 78,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e0097a03-a173-411a-bd5a-6fb553ead63a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1345,
      y: 144,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd1d7057f-0766-4dd4-9051-7e56ab498793',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1268,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '486f99c5-0fc2-45d2-9124-2bac171551b9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1628,
      y: 30,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '917a35c7-3045-48be-b505-aa4bfab11426',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1552,
      y: 78,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c473d06d-e4d8-449a-b143-43b1742a6fc6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1474,
      y: 137,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '17d4e9a6-5f8f-42fc-a728-e23eb8f6886b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1406,
      y: 185,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'eed0551c-74e0-479a-a820-5e2337446e70',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1349,
      y: 236,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '568ff6a0-35fc-4f10-9faa-e568a0ffae2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1747,
      y: 34,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ba779a86-ddad-49e0-b700-883d1ccfefb8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1667,
      y: 96,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '1c802caf-845d-4f96-92cc-3be0f69d1bb8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1584,
      y: 157,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd482497f-d744-428c-9ba6-a37ee541da7e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1505,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '774eed84-8e56-46fd-8f15-cfcbff51de8e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1420,
      y: 292,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'cc3e1503-c989-40a3-8e6a-1a3b63ed9634',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1857,
      y: 34,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '7923ba13-dd71-4382-b8a5-25cdab161ef6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1776,
      y: 101,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '6cba6028-39b9-4f24-b0e0-de168310f337',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1694,
      y: 162,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '1f596a38-9aab-46b9-83ff-1530c87522f3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1603,
      y: 224,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd94f16f7-43ac-4926-b340-ccad7a2fac9a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1510,
      y: 289,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '2269b182-9d28-472f-960c-d9040d07ccf0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1696,
      y: 523,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '00332dcb-75b1-4cda-a4ed-1acc71e9878c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1769,
      y: 576,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '5957fa30-54d0-4dd9-82fa-df34fe825383',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1852,
      y: 646,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '15111b99-d93d-4dd0-ab35-5f7a1643b374',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1961,
      y: 654,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '2b343b92-1ee7-4e71-9e20-22a92440f402',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2034,
      y: 716,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '3745829a-94e7-46f6-9a10-d5fadcd6fad9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1940,
      y: 716,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '0fdf211f-127a-4e04-ab48-2da3c87eff5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2019,
      y: 782,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '65bad2a1-6b8c-4d57-9fec-0f48fc89285e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1621,
      y: 551,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '5adf7d47-ce02-49a7-bb47-b349c024d0c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1630,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f65b6979-fa2b-4131-95db-074d16eace5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1706,
      y: 626,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '1c4947a2-f01d-42af-906e-791f7db2858c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1780,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '83c97b2e-289f-4795-8941-d64a42dac314',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1864,
      y: 762,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ca5be3a3-f222-4279-b1a6-906c82e1fc3b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1937,
      y: 847,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '7af72dfe-7e2e-4938-b894-e45c50366f57',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1527,
      y: 591,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '3bfa44c0-3b51-4f3e-88e8-a5e22180e055',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1576,
      y: 669,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '06a3d1a1-e039-4dcd-95d9-504694ee18ff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1688,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '265406e7-b3e9-4836-ad9f-cab9fd756ca0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1770,
      y: 809,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '25543634-723d-427d-9d45-45b78a17dfe4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1897,
      y: 90,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '9f0cf3f0-6854-487b-905c-9eb0b27d7176',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1819,
      y: 147,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '63538e05-3099-4534-ae86-1efeccaf9f5a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1170,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c8299d7c-b969-4c24-bc20-18c0ce0a1b92',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1105,
      y: 728,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f6d706e8-5441-4e51-8ef4-2ccb3c739b36',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1044,
      y: 799,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a3c0bcd6-fee3-44db-9811-b0dd302c92dc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 819,
      y: 785,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '74',
      data: ''
    },
    {
      id: '0d1c64b4-dfdb-44ed-8ee1-f4c54cc59ff5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2245,
      y: 41,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '1a503bab-fbcf-4ed6-ab87-b3fe131308c4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2166,
      y: 104,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f27d94c3-97a3-49c2-acfd-eaa16668593e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2085,
      y: 164,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '5e421bbc-2ab3-470c-a12f-b6b77cdf7725',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2007,
      y: 229,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'a11b4c0e-5101-4af7-a0f2-eb70d9494105',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1925,
      y: 297,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'a179be12-96bb-4710-8734-aed8d149deb9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2378,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '3010405d-2c46-4376-bfbc-4d82749812d1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2302,
      y: 96,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'bc4e69a8-4289-4a56-b1a7-197dcb00b1a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2227,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'fb916e75-6f46-4916-ad8d-131b1fc497cb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2147,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'afc03ea7-008e-4292-b1d5-2f516812ddc1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2068,
      y: 278,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '667eea83-8d07-454a-834a-2f88ecd711b3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2001,
      y: 340,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '5be311b4-c1bb-4f16-b30c-30bc7c26b929',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2450,
      y: 79,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c7aa5a79-142c-48dd-8bb9-c94634511907',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2529,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '9f30cdb7-ec03-4cd3-87fa-e085666d62d7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2597,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '4dd86713-65ce-41a9-af4f-01d249e1a956',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2368,
      y: 150,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'a4d8f1b5-b050-4e33-aa87-4c4425adeb1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2554,
      y: 120,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '51221a01-b83e-49c9-8243-589b6f096fd9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2289,
      y: 208,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '7c04c707-7c0a-4788-8de1-2c4e06c7fbc4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2199,
      y: 274,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '3ad26937-e92f-4e54-bb0a-79dc8c2fa2cc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2110,
      y: 341,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '6ad21a81-4848-4e96-a505-d7ce7e2f704e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2464,
      y: 167,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'd6d029d8-9c68-41e8-82a3-eacf4b7e8fff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2381,
      y: 233,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '0ae91902-5093-496e-9fe6-5e49066b3c48',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2290,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'a9d1b29f-7c6b-438c-a71b-651af6882daf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2525,
      y: 219,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '7709d1f2-8b69-48ef-931d-30cc0a486aea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2434,
      y: 288,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b02c60c9-9cd7-46c3-b704-beb8e2c456c3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2345,
      y: 359,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '968545ea-e121-45bf-bd65-c8b2129a7553',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2580,
      y: 260,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '03aa9cf7-706c-46ce-9581-c57835a6384b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2495,
      y: 331,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '4d18a4e1-d2f3-4a5e-854f-ecc605a887bf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2420,
      y: 386,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f7f0704c-6753-4555-934c-1439a173357b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2161,
      y: 633,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '388f742c-164f-4c4d-aa67-7e9197849f7f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2121,
      y: 811,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b4ce3e15-c703-46fb-a926-20b5ac278694',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2307,
      y: 674,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'e0760859-55c3-487f-b824-9266c9c85e43',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2233,
      y: 693,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'dfc13daf-cda1-4aa6-92d1-c9f38c02342a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2318,
      y: 746,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '5c694cb2-60d6-4e9a-9ac7-4a08c5914224',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2417,
      y: 695,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '87d300cf-4d6b-4bd6-8f29-fbd2184aba63',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2524,
      y: 670,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '86c9a125-3524-42af-a4f7-e44fbd3b0fb3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2626,
      y: 595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '4424f9f9-55e9-4543-931b-e44a1b4a7498',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2625,
      y: 698,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '4852491c-ae65-4e88-825b-2016f2ea61c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2444,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '33502680-953a-4952-b38b-9348b6be481f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2368,
      y: 824,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: 'cb418330-0a1d-417a-9ab5-41c3a2cca317',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2546,
      y: 756,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '5175f1a9-b3c0-4043-ba34-b3672121c453',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2482,
      y: 835,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '01f2a5c0-76c6-4469-980d-93c21b40cda3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2618,
      y: 818,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_4',
      parent: '110',
      data: ''
    },
    {
      id: '0f9f5bc2-6642-408c-b628-4b5799f0f698',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2804,
      y: 645,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '697012b7-1d88-452c-95c1-24bc9beb23b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3347,
      y: 554,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: 'b592e533-dea6-45a8-a964-b84678acba34',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3347,
      y: 554,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '1ea93338-fc06-470f-bc77-3cc274c689eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3468,
      y: 69,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '7f8f94a0-74ab-4f3d-bad6-2b14361797a5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3558,
      y: 200,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: 'e5964493-3a09-48f5-b973-ff4806cbea8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3662,
      y: 81,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: 'f0c64178-45ce-4eb6-981a-cddf07f88046',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3862,
      y: 73,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '7baf6a79-c2bf-4074-9240-5bcbbff53dc7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3775,
      y: 184,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '4ff30715-352a-43ce-a763-1aeebcaa8bc4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4064,
      y: 73,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '9dcdcfcc-c0ef-4395-bbf8-2fca56f937bb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4010,
      y: 206,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: 'f10b72dc-40be-400d-bf64-ff8123ca46b0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4239,
      y: 131,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '96781eae-7c93-46bf-ad09-73a4e4f9984d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4187,
      y: 246,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '21ca59a6-26db-498d-a8dc-61bd8ca660c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4386,
      y: 293,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: 'd950f459-9eed-41ad-b233-b9a3bb17c32e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3716,
      y: 317,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '48cf388e-35de-475c-bae2-eeecc976efc0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3890,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '9d76a37a-a735-4c3e-afdd-7bdfc62dc339',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2986,
      y: 671,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: 'b138d081-e400-423e-bec9-bfa998bded8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3188,
      y: 634,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '73a618b2-5aa9-4fb9-9627-3039fba6b50b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3529,
      y: 646,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '98ca4509-47bf-4fe4-9726-a961ccc20d24',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3354,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '7d7eb31d-2553-4763-b717-a68acc119d47',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3115,
      y: 771,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '2155089d-df6a-4005-8e77-d84e4cf3f138',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2873,
      y: 831,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '9f52d41a-e67e-43d7-9348-c2e902efc281',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3559,
      y: 831,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: 'ac4193ca-a178-4104-af12-bcff178f346b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3299,
      y: 904,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '164',
      data: ''
    },
    {
      id: '986e7ba1-5b0f-4acd-ab15-17258a5bb495',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4245,
      y: 641,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: '3d32acfe-dc89-4028-92b0-1e94e566407e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4440,
      y: 719,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: 'f925a8b2-1b9c-479f-9c31-f9f3525d4a8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4274,
      y: 854,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: '1398d36a-2ffe-40b5-a81a-79cf2656e26b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4657,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: '5867c93c-aab6-4d41-9271-8e27f448093f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4875,
      y: 659,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: '96f3163c-cde0-45d8-9ce4-2cf33bc40bb4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4996,
      y: 848,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: '8c1c4fd8-9bd2-4b1a-b13e-d4613d57c8fa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4779,
      y: 797,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: '29d8b041-8876-4128-a25f-20bb74fe404b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4557,
      y: 853,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_4',
      parent: '185',
      data: ''
    },
    {
      id: 'bb7558c7-9e1d-4674-9e1a-09f7a12c9722',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5947,
      y: 40,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'd2b82acb-6aa3-46c6-afec-56a45b9690fd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5846,
      y: 100,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '830942a4-322e-4b34-bf3f-c5688dc64775',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5746,
      y: 162,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '4529a6b4-79af-4fe3-8e67-17b0835b2966',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6078,
      y: 50,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'e97210ba-314d-449b-972a-68f823b9a9dd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5953,
      y: 123,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '1756f3fc-46c5-4043-815b-44f3fef61e77',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5836,
      y: 198,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ba8ec9e3-88d5-4c64-978d-6f1a8889bfd3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5716,
      y: 279,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '8967ea03-1148-4543-9481-27d049b33f4c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6177,
      y: 75,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '8e338d14-10e4-4a16-9407-83d067a8a186',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6059,
      y: 149,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'eb9ce1eb-e462-4e84-8fe3-e7c8f4351d8f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5945,
      y: 226,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '64497571-26ff-42dc-a6bd-a30b6a11903e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5830,
      y: 297,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '3134ef91-8269-45ea-8386-33f055cfc87f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5716,
      y: 391,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '5cc6671a-91a6-41bf-8839-e16b2d6b7ea0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6283,
      y: 99,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '827958cd-90df-49c6-b13f-658ac498af2a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6176,
      y: 171,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '524002f6-5b03-4515-ad6e-b9e1647d3cc5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6066,
      y: 245,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'e50787b5-a490-4fc8-98aa-f6c11361a387',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5944,
      y: 323,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '9b5b6c59-d3af-437f-8b0d-02ecab4eae15',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5840,
      y: 409,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'db171e03-f90a-4b59-aa89-eb1fcc9e0246',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6408,
      y: 119,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '2e3ac77c-9ebf-42e0-a3e9-f885773de81e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6299,
      y: 191,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f3bae68f-efdc-42a4-9cf2-ff4c712b79c7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6185,
      y: 271,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '34da739d-e0ec-4eb9-a0cd-125431e7741a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6070,
      y: 338,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '6b821986-828e-42e7-89f2-5e24aba2c7a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5966,
      y: 413,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'cf1e63e6-5630-42e2-b02c-230d4284f9b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5564,
      y: 647,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'b42c9e4d-4a26-45a4-a4ca-424a07f64bbb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5540,
      y: 748,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '9fae1e1b-8331-4cd1-bcc0-0deb43140b82',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5679,
      y: 712,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'd26dbf74-89cd-40ed-bad3-0d4f74155664',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5819,
      y: 706,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ca74c535-7e4c-4ae1-85b2-1cbad5cbcc49',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5966,
      y: 710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '1a85d932-02f8-4092-97c7-f992d60af89f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5735,
      y: 787,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'a8236223-fbc9-4a22-b981-35ad4187b8a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5618,
      y: 815,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '2b73b43c-911a-4f3d-9222-9d67af68c64a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5880,
      y: 781,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'c7894ddd-60ef-47b7-9b7a-7e537a75e400',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6042,
      y: 761,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '726e8c69-29a3-4c04-9391-40e8b7c375d8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5973,
      y: 861,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '0f568011-353b-47b0-8654-2aeef1d6dc7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6594,
      y: 601,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '1051deb6-0ada-4f93-a568-74ee215dc574',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6378,
      y: 548,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f50a5106-8e59-4244-b02e-f1ec8af88e58',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6475,
      y: 614,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'b8b5d23d-e151-4da7-97d5-2f59196c8a2e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6565,
      y: 711,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '7adafb1f-bad5-4423-bad8-5888e0186f9a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6262,
      y: 590,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '87ca8c88-fd3b-47dc-a7a0-d2b6b7eef2e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6366,
      y: 662,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'b47382d9-f0b5-4cf1-a239-177e2c9cfcc0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6156,
      y: 640,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '206d63f3-4ad3-471d-94eb-ff866825c3c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6264,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '682e1cf0-c793-46b5-b43d-c2ee6b897a06',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6460,
      y: 739,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '386b573b-4e27-4863-b3b0-d93ecc5bcc39',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6350,
      y: 812,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '205611f7-dcd2-4f22-939a-ac71d4f6fc8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6508,
      y: 859,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '7a64611c-95bb-407b-90ae-2d96a5b4a769',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6667,
      y: 681,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '3766978b-c0ce-498a-8ddb-31a57a83ec0a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6423,
      y: 211,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'faa87e4a-712b-4984-a2b9-6b2d930e1b18',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6306,
      y: 277,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '9e5293b1-b777-429b-86c0-270077553158',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6534,
      y: 230,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: '51784713-62bf-4930-950c-e2a57c1c2b34',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6435,
      y: 291,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ba1bb63e-3338-4b75-aded-9c94dc09323f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6559,
      y: 313,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f39e64cb-1e58-46e5-a337-9cf3bcdf93ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7477,
      y: 48,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '785e0f00-8e3f-43f2-b56e-e17e25a61875',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7598,
      y: 75,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '00ce7d05-79cb-4947-9428-fcfc0c0a4683',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7491,
      y: 160,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '48564f27-e324-4e49-b68c-c6d591b45660',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7687,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f1aada5d-f0df-4fe0-967f-11c1a1ea9051',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7585,
      y: 230,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '415e301d-7a79-41d5-858a-b742a1f62d69',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7776,
      y: 57,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'cfdf4f2d-02a2-47f7-9835-47447ad7f064',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8004,
      y: 38,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '8b5e7138-6a08-497c-bff9-f50209e577f2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7806,
      y: 206,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '67a34732-a194-48a9-8f34-6656b7c8cb77',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7690,
      y: 291,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'cf97d405-9f72-4a73-96a2-a7b24e7ee8fb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7908,
      y: 120,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '295e64c5-d4eb-4605-acd1-573c26fe7406',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7215,
      y: 585,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'dd0b6197-f115-434d-bdf9-dc80c0b2d507',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7336,
      y: 633,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '32a9ce92-7788-4e7d-9a48-eec29c690ee3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7094,
      y: 655,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '92d91543-3c48-4582-857d-f0039a9f3235',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7046,
      y: 776,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b038d08e-776d-421d-a56a-174709864fcc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7220,
      y: 724,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '0fe76a7d-22f3-49e0-adbe-29a6ba8a41d1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7486,
      y: 676,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b74ce856-d069-45be-86ff-5196091c0174',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7368,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '2bafcec6-88a8-410a-abf7-7c66b4d970ed',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7503,
      y: 808,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'c6e2d680-5a99-4429-b3dd-4b7fe12e16df',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7624,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '99daafd2-025d-4bf7-afbd-56c4be0791af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7156,
      y: 846,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a114baf9-1a8c-485a-8b11-d54958a8b201',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7297,
      y: 844,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b6c24811-472d-47f7-9656-a315c7460474',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7881,
      y: 654,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '6a7abc03-2200-4c97-8165-5815ae89d962',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7992,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '61fb501a-f41b-4cc1-8398-814c58fc8926',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7990,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_4',
      parent: '219',
      data: ''
    },
    {
      id: '85d1911c-be3e-4628-b915-bb6ade0a142c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8522,
      y: 11,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '1d78e2f1-2eed-48d7-a7ab-53e4041afda1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8397,
      y: 104,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e379f9e1-9298-4d55-bca5-cecbaae71963',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8262,
      y: 197,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '98d94cac-8b33-40ab-943c-3fb0031364bc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8765,
      y: 61,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '567a0ab5-5b0d-448a-8a83-ae479ef8bc16',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8440,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '8bf8b0c7-2d59-40a4-baed-68fd65e28103',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8612,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '29a87aa1-d1ba-4db0-b8bc-c8b5cbdab267',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8650,
      y: 271,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c83e19eb-94a2-4411-bb54-e3b38302c1cf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8777,
      y: 370,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '35afe85d-b209-4f41-bc52-450067cb2d3c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8291,
      y: 562,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '1941299b-24bb-4a9c-a821-4d4368c19f18',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8480,
      y: 583,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e20003e1-ec4c-4412-9d2a-390f48be545f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8389,
      y: 697,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '31f8152f-ea59-4b51-9e6d-451254d6330c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8615,
      y: 711,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'db765f8c-deaf-4299-868a-b9d5a6121890',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8804,
      y: 741,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '66189bc5-5423-4b46-bbe1-4eb6de50191a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8994,
      y: 653,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '8bf82266-cd79-458e-9e41-6789225602cf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9195,
      y: 670,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c49ad1e1-caaa-42f7-9787-563645a6c7bb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9363,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'fc48e5b4-35c9-4ca9-b2cf-44d302c83084',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8505,
      y: 839,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e70690c3-0ca0-446d-a5d9-334f55275272',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8733,
      y: 906,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'db35c627-3042-40ce-a0ed-3e1f0c2abb20',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8970,
      y: 826,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e643a582-04cf-4da1-91c8-4f1ea6a3fc30',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9182,
      y: 826,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '224',
      data: ''
    },
    {
      id: '17fa669a-7cd6-49a7-a748-ce03de68bf05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9628,
      y: 89,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b0bb2e6b-4dbe-4348-a6b4-1fa8697c616b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9485,
      y: 196,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'e363b201-b629-445b-932f-1bc667b2e01e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9342,
      y: 310,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '7334d3bb-d0e1-46ba-825a-61cf315fa141',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9643,
      y: 256,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f92189a2-de12-47ba-8df4-219aca888e27',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9506,
      y: 383,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'c9705ec3-0785-4d8c-8524-8e2e7f5c7f63',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9820,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '382e790a-18e2-4c7e-9e6a-541ba739142e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9805,
      y: 755,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'e654dce6-0c77-40d6-9e10-42fe9a1dabf5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9991,
      y: 774,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '752f6dbb-171d-4028-ab44-922a145bb8ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9882,
      y: 927,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '7a9d8e5d-fdfd-4c9f-b598-04981e233a4a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9816,
      y: 235,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1045,
      y: 559,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '106',
      data: ''
    },
    {
      id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2251,
      y: 226,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '160',
      data: ''
    },
    {
      id: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3630,
      y: 145,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '181',
      data: ''
    },
    {
      id: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4934,
      y: 520,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '210',
      data: ''
    },
    {
      id: '107',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6433,
      y: 198,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '215',
      data: ''
    },
    {
      id: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7765,
      y: 142,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '220',
      data: ''
    },
    {
      id: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8696,
      y: 223,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '225',
      data: ''
    },
    {
      id: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9681,
      y: 194,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '230',
      data: ''
    },
    {
      id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '85746295-e987-4e2b-a7d0-6791216b55a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_harvest_map',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '656a5808-34d6-4751-a733-6af98d163ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'soybeans_harvest_map',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: 'c001f4bb-2f73-4bf8-8953-deb543c31f21',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: 'c41c933b-373f-4a3d-bdc7-f748ce87c274',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_harvest_map',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: '16ac1fb4-d061-449e-87ad-02f0d5dff6e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '958851db-006d-425c-afff-a85018a3cb2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'banana_harvest_map',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '108',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '107',
      data: ''
    },
    {
      id: '109',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_harvest_map',
      parent: '107',
      data: ''
    },
    {
      id: '46aeb65d-4896-4557-9865-75ef0057e163',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: 'ac0db26e-8010-4059-87b0-18b44d3c25ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'cassava_harvest_map',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: '03074616-c479-4d19-9e8c-855582627513',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '018bb44b-6ca0-491c-b479-368ca2fa6897',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_harvest_map',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '2e08b7f7-57a1-4e7c-baf5-459d9f88afdd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    },
    {
      id: 'c077834a-7855-43ec-a465-2f5ed5df5421',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'guarana_harvest_map',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class WorldLayout20 {
  static raw = raw;
  root: PIXI.Container
  backgrounds: PIXI.Container
  nodesContainer: PIXI.Container
  cropsSectorA: (PIXI.Container)[]
  cropsSectorB: (PIXI.Container)[]
  signsSectorA: (PIXI.Container)[]
  signsSectorB: (PIXI.Container)[]

  constructor() {
    populate(this, raw);
  }
}
